import { render, staticRenderFns } from "./ModalCadastrarEleicoes.vue?vue&type=template&id=5a138ec3"
import script from "./ModalCadastrarEleicoes.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarEleicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports